import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Stack,
  FormControlLabel,
  Checkbox,
  Paper
} from "@mui/material";
import { createNews, getImage } from "../services/api/stayInTouchApi";
import { Snackbar, Alert } from "@mui/material";
export default function StayInTouch() {
  const [images, setImages] = useState([]);
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    location: "",
    mobile: "",
    preference_id: [],
    child_stage_id: [],
    email_receive: false,
    confirm18: false,
  });

  const preferenceOptions = [
    { id: 1, label: "Skin Care" },
    { id: 2, label: "Baby" },
    { id: 3, label: "Makeup Remover" },
    // { id: 4, label: "Teen" },
    // { id: 5, label: "Older Skin/Carer" },
  ];

  const childStageOptions = [
    { id: 1, label: "Newborn" },
    { id: 2, label: "Infant" },
    { id: 3, label: "Toddler" },
    { id: 4, label: "Kids" },
    { id: 5, label: "Teens or older" },
    { id: 6, label: "None" },
  ];

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await getImage();
        setImages(res || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchImages();
  }, []);
  const img1 = images[0]?.image;
  const img2 = images[1]?.image;
  const img3 = images[2]?.image;
  const img4 = images[3]?.image;
  const img5 = images[4]?.image;


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    // 🔥 remove error when user starts typing
    setErrors((prev) => ({
      ...prev,
      [name]: value ? "" : prev[name],
    }));
  };

  const handleCheckboxChange = (name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));

    // 🔥 remove error instantly
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleMultiSelect = (name, value) => {
    const arr = formData[name];

    const updated = arr.includes(value)
      ? arr.filter((i) => i !== value)
      : [...arr, value];

    setFormData((prev) => ({
      ...prev,
      [name]: updated,
    }));

    // 🔥 remove error if at least 1 selected
    if (updated.length > 0) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const response = await createNews(formData);

      // ✅ Toast show
      setToast({
        open: true,
        message: "Thank you for joining us!",
        severity: "success",
      });

      // ✅ Reset form
      setFormData({
        name: "",
        email: "",
        location: "",
        mobile: "",
        preference_id: [],
        child_stage_id: [],
        email_receive: false,
        confirm18: false,
      });

      setErrors({});

    } catch (error) {
      console.error("Error:", error);
      setToast({
        open: true,
        message: "Something went wrong. Please try again.",
        severity: "error",
      });
    }
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.email) newErrors.email = "Please complete this required field.";
    if (!formData.name) newErrors.name = "Please complete this required field.";
    if (!formData.location) newErrors.location = "Please complete this required field.";
    if (!formData.mobile) newErrors.mobile = "Please complete this required field.";

    if (formData.preference_id.length === 0)
      newErrors.preference_id = "Please complete this required field.";

    // if (formData.child_stage_id.length === 0)
    //   newErrors.child_stage_id = "Please complete this required field.";

    if (!formData.confirm18)
      newErrors.confirm18 = "Please complete this required field.";

    if (!formData.email_receive)
      newErrors.email_receive = "Please complete this required field.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const whiteCheckboxStyle = {
    color: "primary.contrastText",
    "&.Mui-checked": { color: "primary.contrastText" },
  };

  return (
    <>
      <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "common.white" }}>
        <Box
          sx={{
            maxWidth: "1440px",
            width: "100%",
            mx: "auto",
            px: { xs: 3, sm: 2, md: 2, lg: 4 },
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "6fr 5fr",
              },
              gap: { xs: 4, md: 3 },
              alignItems: "flex-start",
            }}
          >
            {/* ================= LEFT IMAGES ================= */}
            <Box
              sx={{
                order: { xs: 2, md: 1 },
                display: "flex",
                flexDirection: "column",
                gap: { xs: 2, md: 3 },
                maxWidth: { md: 620 }, // 👈 control image area
                width: "100%",

                ml: { md: 4 }   // try 2, 3, 4, 6 (spacing control)
              }}
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box
                  component="img"
                  src={img2}
                  sx={{
                    width: "35%",
                    height: "40%",
                    mt: 7,
                    aspectRatio: "1/1",
                    borderRadius: 3,
                    objectFit: "cover",
                  }}
                />
                <Box
                  component="img"
                  src={img1}
                  sx={{
                    width: "55%",
                    aspectRatio: "1/1",
                    borderRadius: 4,
                    objectFit: "cover",
                  }}
                />
              </Box>

              <Box sx={{ display: "flex", gap: 2, }}>
                <Box
                  component="img"
                  src={img3}
                  sx={{
                    width: "55%",
                    aspectRatio: "1/1",
                    borderRadius: 4,
                    objectFit: "cover",
                  }}
                />
                <Box
                  component="img"
                  src={img4}
                  sx={{
                    width: "35%",
                    height: "40%",
                    mt: 7,
                    aspectRatio: "1/1",
                    borderRadius: 3,
                    objectFit: "cover",
                  }}
                />
              </Box>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={img5}
                  sx={{
                    width: { xs: "60%", md: "50%" },
                    aspectRatio: "1/1",
                    borderRadius: 4,
                    objectFit: "cover",
                  }}
                />
              </Box>
            </Box>

            {/* ================= RIGHT FORM ================= */}
            <Paper
              elevation={0}
              sx={{
                order: { xs: 1, md: 2 },
                borderRadius: 4,
                backgroundColor: "primary.main",
                color: "primary.contrastText",
                p: { xs: 2, sm: 4 },
                width: "100%",
                maxWidth: { xs: "100%", sm: 480, md: 540 },
               
                mr: { md: 4 },
              }}
            >
              <Box component="form" onSubmit={handleSubmit}>
                <Typography variant="subtitle2" sx={{ opacity: 0.85, mb: { xs: 1, sm: 2, md: 3 } }}>
                  Let’s stay in touch
                </Typography>

                <Typography variant="h4" sx={{ fontWeight: 600, mb: { xs: 1, sm: 2, md: 3 } }}>
                  Join us for news and updates.
                </Typography>

                <Typography sx={{ opacity: 0.9, mb: { xs: 2, sm: 3 } }}>
                  Get the latest on new products and stories from our community.
                </Typography>

                <Stack spacing={2}>
                  {[
                    { name: "email", label: "Email Address*", placeholder: "Enter your email" },
                    { name: "name", label: "Name*", placeholder: "Enter your name" },
                    { name: "location", label: "Location*", placeholder: "Enter your location" },
                    { name: "mobile", label: "Contact Number*", placeholder: "Enter your contact number" },
                  ].map((f) => (
                    <Box key={f.name}>
                      <Typography sx={{ fontWeight: 500 }}>{f.label}</Typography>
                      <TextField
                        fullWidth
                        name={f.name}
                        value={formData[f.name]}
                        onChange={handleChange}
                        placeholder={f.placeholder}
                        error={!!errors[f.name]}
                        helperText={errors[f.name] || " "}
                        FormHelperTextProps={{
                          sx: { color: "#fff !important", fontSize: 15 },
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "999px",
                            backgroundColor: "#fff",
                            height: 46,
                          },
                          "& .MuiFormHelperText-root": {
                            minHeight: "20px",
                          },
                        }}
                      />
                    </Box>
                  ))}

                  {/* PREFERENCE */}
                  <Box>
                    <Typography sx={{ fontSize: 14, mb: 2 }}>
                      Your choices matter! Pick your preference*
                    </Typography>

                    <Grid container spacing={1}>
                      {preferenceOptions.map((item) => (
                        <Grid item xs={6} sm={4} key={item.id}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.preference_id.includes(item.id)}
                                onChange={() => handleMultiSelect("preference_id", item.id)}
                                sx={whiteCheckboxStyle}
                              />
                            }
                            label={item.label}
                          />
                        </Grid>
                      ))}
                    </Grid>

                    {errors.preference_id && (
                      <Typography sx={{ color: "#fff", fontSize: 15, mt: 1 }}>
                        {errors.preference_id}
                      </Typography>
                    )}
                  </Box>

                  {/* CHECKBOX 1 */}
                  <Box>
                    <FormControlLabel
                      sx={{
                        alignItems: "flex-start",
                        "& .MuiFormControlLabel-label": { textAlign: "justify" },
                      }}
                      control={
                        <Checkbox
                          checked={formData.confirm18}
                          onChange={() => handleCheckboxChange("confirm18")}
                          sx={{ ...whiteCheckboxStyle, paddingTop: 0 }}
                        />
                      }
                      label="I confirm I am over 18 years old and agree to Terms and Privacy Policy."
                    />

                    {errors.confirm18 && (
                      <Typography sx={{ color: "#fff", fontSize: 15 }}>
                        {errors.confirm18}
                      </Typography>
                    )}
                  </Box>

                  {/* CHECKBOX 2 */}
                  <Box>
                    <FormControlLabel
                      sx={{
                        alignItems: "flex-start",
                        "& .MuiFormControlLabel-label": {
                          textAlign: "justify",
                        },
                      }}
                      control={
                        <Checkbox
                          checked={formData.email_receive}
                          onChange={() => handleCheckboxChange("email_receive")}
                          sx={{ ...whiteCheckboxStyle, paddingTop: 0 }}
                        />
                      }
                      label="I would like to receive emails about offers and promotions."
                    />

                    {errors.email_receive && (
                      <Typography sx={{ color: "#fff", fontSize: 15 }}>
                        {errors.email_receive}
                      </Typography>
                    )}
                  </Box>

                  <Button
                    type="submit"
                    sx={{
                      backgroundColor: "background.default",
                      color: "secondary.contrastText",
                      borderRadius: "999px",
                      fontWeight: 600,
                      py: 1.2,
                      mt: 1,
                    }}
                  >
                    Submit
                  </Button>
                </Stack>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>

      {/* SNACKBAR */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setToast({ ...toast, open: false })}
          severity={toast.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </>
  );
}
